import { request } from "../../client";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useGlobalState } from "../../../GlobalStateProvider";
import AddLinkButton from "../../../../components/AddLinkButton";
import EditAndDeleteLinkButtons from "../../../../components/EditAndDeleteLinkButtons";
import PropTypes, { InferProps } from "prop-types";

export function AssessmentsPage(props: InferProps<typeof AssessmentsPage.propTypes>) {

  // Hooks
  const navigate = useNavigate();

  // Global State
  const { globalState, } = useGlobalState();

  // State
  const [items, setItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [showDeleted, setShowDeleted] = useState(false);

  // Mount
  useEffect(() => {
    fetchItems(showDeleted);
  }, []);

  // Event handlers
  const onAddClickHandler = function () {
    navigate("/app/assessments/new");
  }

  const onEditClickHandler = function (id: string) {
    navigate(`/app/assessments/${id}`);
  }

  const onEditDetailClickHandler = function (id: string) {
    navigate(`/app/assessments/${id}/items`);
  }

  const onPrintClickHandler = function (id: string) {
    navigate(`/app/assessments/${id}/report`);
  }

  const onDeleteClickHandler = function (id: string, name: string) {

    if (!window.confirm(`Möchten Sie die Lernstandserfassung '${name}' wirklich löschen?`)) {
      return;
    }

    deleteItemApi(globalState.apiBaseUrl, id)
      .then(() => {
        fetchItems(showDeleted);
      })
      .catch((ex: any) => {
        alert(`Error: ${ex}`);
      })
  };

  // Functions
  const fetchItems = function (includeDeleted: boolean) {
    fetchItemsApi(globalState.apiBaseUrl, includeDeleted)
      .then((result: any) => {
        setItems(result);
        applyFilter(result, filterText);
      })
      .catch((ex: any) => {
        alert(`Error: ${ex}`);
      });
  };

  const applyFilter = function (loadedItems: any, text: any) {
    if (!text || text.length === 0) {
      setFilteredItems(loadedItems);
      return;
    }

    const searchText = text.toLowerCase();

    const res = loadedItems.filter((i: any) => {
      if (i.lastname && i.lastname.toLowerCase().indexOf(searchText) !== -1) {
        return true;
      } else { return false; }
    });

    setFilteredItems(res);
  };

  // Web api calls
  const fetchItemsApi = async function (apiBaseUrl: string | undefined, includeDeleted: boolean) {
    return request(`${apiBaseUrl}/assessment?familyId=${globalState.familyId}&includeDeleted=${includeDeleted}`, globalState.authToken);
  }
  const deleteItemApi = async function (apiBaseUrl: string | undefined, id: string) {
    const options = { method: "DELETE" };
    return request(`${apiBaseUrl}/assessment/${id}`, globalState.authToken, options);
  }

  return (
    <div className="card">
      <table className="table table-rounded table-striped border gy-7 gs-7">
        <thead>
          <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
            <th className="lp21-command"><AddLinkButton isReadOnly={props.isReadOnly} onAddClick={onAddClickHandler} /></th>
            <th>Datum</th>
            <th>Bewertungsart</th>
            <th>Kind / Schuljahr</th>
            <th>Status</th>
            <th className="text-center">Bewertungen</th>
            <th className="text-center">Texte</th>
            <th className="text-center">Bilder</th>
          </tr>
        </thead>
        <tbody>
          {items && items.map((item: any) => <tr key={item.id}>
            <td className="lp21-command"><EditAndDeleteLinkButtons id={item.id} name={new Date(item.date).toLocaleDateString("de-CH")} isDeleted={item.deleted} isReadOnly={props.isReadOnly} onEditClick={onEditClickHandler} onDeleteClick={onDeleteClickHandler}
              showEditDetail={true} editDetailLabel="Einträge editieren" onEditDetailClick={onEditDetailClickHandler}
              showPrint={true} printLabel="Drucken" onPrintClick={onPrintClickHandler}>
              <>
                <div className="menu-item px-3">
                  <Link className={`menu-link px-3 ${items.length <= 1 ? "disabled-link" : ""}`} to={`/app/assessments/${item.id}/copy`} title="Mit dieser Funktion lassen sich der Lernstand und/oder die Bemerkungen von einer anderen Lernstandserfassung übernehmen.">
                    <i className="bi bi-box-arrow-in-right text-primary fs-4"></i>&nbsp;Einträge kopieren...
                  </Link>
                </div>
              </>
            </EditAndDeleteLinkButtons></td>
            <td>{new Date(item.date).toLocaleDateString("de-CH")}</td>
            <td>{item.assessmentSchemaName}</td>
            <td>{item.childGradeLevelName}</td>
            <td>{item.assessmentStatusName}</td>
            <td className="text-center">{item.levelsCount}</td>
            <td className="text-center">{item.remarksCount}</td>
            <td className="text-center">{item.imagesCount}</td>
          </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

AssessmentsPage.propTypes = {
  isReadOnly: PropTypes.bool.isRequired
};

export default AssessmentsPage;